import { ModelBase } from 'store/model-base';

export class LevelMoveEligibility extends ModelBase {
    public static storeName: string = 'levelMoveEligibility';

    public isEligible: boolean;
    public toLevel: string;
    public denialReason: LevelMoveDenialReason[];
    public recommendations: LevelMoveRecommendation[];
}
